/* eslint-disable indent */
import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialog, PageEvent, MatCheckboxChange } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { DetalheProdutoModalComponent } from '../modals/detalhe-produto-modal/detalhe-produto-modal.component';
import { DigitaCampoModalComponent } from '../modals/digita-campo-modal/digita-campo-modal.component';
import { PotenciaKitsModalComponent } from '../modals/potencia-kits-modal/potencia-kits-modal.component';
import { SelecionaKitModalComponent } from '../modals/seleciona-kit-modal/seleciona-kit-modal.component';
import { Cliente } from '../models/cliente';
import { ItemPedido, Pedido } from '../models/pedido';
import { Produto, ProdutoDesconto } from '../models/produto';
import { VendaEntrega } from '../models/venda-entrega';
import { CarregandoService } from '../services/carregando.service';
import { ClienteService } from '../services/cliente.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PedidoService } from '../services/pedido.service';
import { PremissasService } from '../services/premissas.service';
import { ProdutoService } from '../services/produto.service';
import { LogAcesso } from '../models/log-acesso';
import { TipoArquivo, TipoDeLogAcesso } from '../models/enum';
import { LogAcessoService } from '../services/log-acesso.service';
import { UtilitarioService } from '../services/utilitario.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Filtro } from '../models/filtro';
import { Marca } from '../models/marca';
import { MarcaService } from '../services/marca.service';
import { ClientesModalComponent } from '../modals/clientes-modal/clientes-modal.component';
import swal from 'sweetalert2';
import { SegmentacaoService } from '../services/segmentacao.service';
import { Fornecedor } from '../models/fornecedor';
import { FornecedorService } from '../services/fornecedor.service';
import { UsuarioLogado } from '../models/usuario-logado';
import { KitFechado } from '../models/kit-fechado';
import { ArquivoService } from '../services/arquivo.service';
import { MenuProdutoService } from '../services/menuprodutoservice';
import { ProdutoCampoPersonalizadoService } from '../services/produto-campo-personalizado.service';
import { MenuProduto } from '../models/menuproduto';
import { MenuSelecionadoService } from '../services/menuselecionado.service';
import { EstruturasPersonalizadas } from '../models/estruturas-personalizadas';
import { PremissasSistema } from '../models/premissas-sistema';
import { PrecificacaoUF } from '../models/precificacao-uf';
import { PrecificacaoUFService } from '../services/precificacao-uf.service';
import { Ibge } from '../models/ibge';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { IbgeService } from '../services/ibge.service';
import { FuncionarioService } from '../services/funcionario.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-kit-fechado',
  templateUrl: './kit-fechado.component.html',
  styleUrls: ['./kit-fechado.component.scss']
})
export class KitFechadoComponent implements OnInit {
  limDesc = undefined;
  vendedor = undefined;
  lojaProdutos = false;
  calculadora = false;
  itens = [];
  idOrcamento: number;
  orcamento: Pedido = new Pedido();
  producaoPorPainel: number;
  quantidadeDePaineis: number;
  potenciaPainel: number;
  potTotal: number;
  potenciaDesejada: number;
  fatorGeracao: number;
  descontosDoProduto: ProdutoDesconto[] = [];
  descontoParaAplicar = {
    valor: 0,
    fornecedor: undefined,
    idProduto: undefined
  };
  descontoMaximo = 0;
  aplicacaoDescontoProgressivo = 0;
  clienteFaturamento: Cliente;
  confirmar = false;
  cancelado = false;
  administrador = false;
  intPodeAlterarCD = false;

  itemSemLote = false;

  integrador = false;
  cliente: Cliente;
  texto = 'Orçamento';
  potMin: number;
  potMax: number;
  filtrouPotencia = false;
  enderecoDeEntrega: VendaEntrega = new VendaEntrega();
  estadoSelecionado = undefined;
  cidadeSelecionado = undefined;

  cidade: Ibge;
  cidades$: Observable<Ibge[]>;
  cidadesLoading = false;
  cidadesInput$ = new Subject<string>();

  pesoBruto = 0;
  multiFornecedores = false;
  calcularFrete = true;
  calcularDesconto = true;
  adicionarVariosKitPronto = false;

  vendaProgramada = false;
  comprovante: any;
  idProduto: number;
  pCentroDistribuicao = false;
  mostrarDescKit = true;
  pUsarAcrescimo = false;
  cds: Fornecedor[] = [];
  produtos: any[] = [];
  kits: any[] = [];
  potenciaParaFiltrar = undefined;
  potenciaParaFiltrarPainel = 0;
  itensFiltrados: ItemPedido[] = [];
  public config: PerfectScrollbarConfigInterface = {};
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  carregando = true;
  listaDeItensPorPagina = [];
  itensPorPagina = 9;
  filtroNome: Filtro = { Propriedade: 'descricao', Valor: '' };
  filtroCodBarra: Filtro = { Propriedade: 'codbarra', Valor: '' };
  filtroFamilia: Filtro = { Propriedade: 'familia', Valor: '' };
  filtros: Filtro[] = [this.filtroNome, this.filtroCodBarra];
  potenciaAte: number;
  marcasPainel: Marca[] = [];
  marcasInversor: Marca[] = [];
  marcaPainelSelecionada: any;
  marcaInversorSelecionada: any;
  telhados: any[] = [];
  telhadoSelecionado: any;
  ordenacoes = [
    { id: 0, nome: 'Mais vendidos' },
    { id: 1, nome: 'Maior valor' },
    { id: 2, nome: 'Menor valor' }
  ];
  ordenacaoSelecionada = 2;
  visualizacaoSelecionada = 0;
  kitsFechadosFiltrados: KitFechado[] = [];

  descontoFrete = undefined;
  clienteIntegrador = undefined;
  nome = undefined;
  calcValorFinalSugestao = false;
  usuarioLogado: UsuarioLogado;
  respostas = [];
  mostrarMsgTrocaCD = { valor: false, msg: '' };
  menusProduto = [];
  menuProdutoSelecionado = undefined;
  camposPersonalizados = [];
  categoriasDoMenu = [];
  categoriasMenuLateral = [];
  textoSelecionadoSubjects = {};
  faixaPreco = { min: 0, max: 0 };
  marcasProduto = [];
  marcasProdutoSelecionadas = new Set<number>();

  bloquearSistema: boolean = false;

  estruturasPersonalizadas: EstruturasPersonalizadas = new EstruturasPersonalizadas();

  precificacoesUF: PrecificacaoUF[] = [];

  premissasSistema: PremissasSistema;

  descAcresPrecificacaoUF: PrecificacaoUF;

  menuOrigem = 0;

  vendPodeAlterarCD = false;

  constructor(
    public dialog: MatDialog,
    private globalService: GlobalService,
    private carregandoService: CarregandoService,
    private produtoService: ProdutoService,
    private router: Router,
    private pedidoService: PedidoService,
    private clienteService: ClienteService,
    private notificacaoService: NotificacaoService,
    private premissasService: PremissasService,
    private logAcessoService: LogAcessoService,
    private utilitarioService: UtilitarioService,
    private marcaService: MarcaService,
    private segmentacaoService: SegmentacaoService,
    private fornecedorService: FornecedorService,
    private arquivoService: ArquivoService,
    private activatedRoute: ActivatedRoute,
    private menuProdutoService: MenuProdutoService,
    private campoPersonalizadoService: ProdutoCampoPersonalizadoService,
    private menuSelecionadoService: MenuSelecionadoService,
    private precificacaoUFService: PrecificacaoUFService,
    private ibgeService: IbgeService,
    private funcionarioService: FuncionarioService
  ) {
    if (this.router.getCurrentNavigation().extras.state) {
      this.idProduto = this.router.getCurrentNavigation().extras.state.idProduto;
    }

    this.activatedRoute.data.subscribe((data) => {
      this.lojaProdutos = data.lojaProdutos;
      this.menuOrigem = data.origem;

      if (this.lojaProdutos) {
        this.globalService.minimizarMenu();
      }
    });
  }

  async InitKitFechado() {
    await this.buscarPremissaVisualizacaoKitFechado();

    this.usuarioLogado = await this.globalService.consultaUsuario();

    this.orcamento.dispEstoque = true;

    this.buscarPremissaUsarAcrescimo();
    this.buscarAdicionarVariosKitPronto();
    this.buscarPremissaVendaProgramada();

    await this.buscarMostrarKitPronto();
    await this.buscarPremissaCentroDeDistribuicao();
    await this.buscarMultiFornecedores();
    await this.buscarPremissaCalcValorFinalSugestao();

    this.buscarMostrarDescKit();

    this.buscarKitProntoFreteDesconto();

    this.integrador = await this.globalService.integrador();
    this.texto = this.integrador ? 'Orçamento' : 'Pedido';

    if (this.calculadora) {
      this.potMax = this.potTotal;
    }

    if (this.integrador) {
      this.orcamento.cliente = this.usuarioLogado.id;
      this.buscarCliente();
    } else {
      if (!this.pCentroDistribuicao || this.multiFornecedores) {
        this.lojaProdutos ? this.buscarProdutosLoja() : this.buscarTodos();
      }
    }

    this.administrador = await this.globalService.administrador();
    this.orcamento.flag = 4;

    this.listarMarcasPainel();
    this.listarMarcasInversor();
    this.buscarUsarTelhadoCeramico();
  }

  async InitLojaProdutos() {
    await this.buscarPremissaCentroDeDistribuicao();
    await this.buscarMultiFornecedores();

    this.usuarioLogado = await this.globalService.consultaUsuario();
    this.buscarMenuProduto();
    await this.buscarCamposPersonalizados();
    this.integrador = await this.globalService.integrador();

    this.texto = this.integrador ? 'Orçamento' : 'Pedido';

    if (this.integrador) {
      this.orcamento.cliente = this.usuarioLogado.id;
      this.buscarCliente();
    } else {
      if (!this.pCentroDistribuicao || this.multiFornecedores) {
        this.lojaProdutos ? this.buscarProdutosLoja() : this.buscarTodos();
      }
    }

    this.administrador = await this.globalService.administrador();
    this.orcamento.flag = 4;

    this.menuSelecionadoService.menuSelecionado$.subscribe((idSelecionado) => {
      const menuSelecionado = this.menusProduto.find((m) => m.idMenu === idSelecionado);

      this.selecionarMenuProduto(menuSelecionado);
    });
  }

  async ngOnInit() {
    this.loadCidade();
    await this.buscarPremissasSistema();

    // if (!this.premissasSistema.habilitarMenuSolar) {
    //   this.router.navigate(['/']);
    // }

    if (!this.premissasSistema.habilitaMenuKitPronto) {
      this.router.navigate(['/']);
    }

    if (this.premissasSistema.usarPrecificacaoPorUF) {
      await this.buscarPrecificacoesUF();
    }

    if (this.lojaProdutos) {
      await this.InitLojaProdutos();
    } else {
      await this.InitKitFechado();
    }

    if (!this.integrador) {
      await this.buscarVendPodeAlterarCD();
    }

    this.buscarPremissasBloqueioSistema();
  }

  buscarPremissasBloqueioSistema() {
    this.carregandoService.mostra('buscarBloqSist');
    this.premissasService.consultarBloqSistManuProd().subscribe(
      (data) => {
        this.bloquearSistema = data;
        this.carregandoService.esconde('buscarBloqSist');
      },
      (erro) => {
        this.carregandoService.esconde('buscarBloqSist');
        this.notificacaoService.erro(erro);
      }
    );
  }

  async buscarPremissaCalcValorFinalSugestao() {
    try {
      this.carregandoService.mostra('buscarPremissaCalcValorFinalSugestao');

      this.calcValorFinalSugestao = (await this.premissasService.consultarCalcValorFinalSugestao().toPromise()).valor;

      this.carregandoService.esconde('buscarPremissaCalcValorFinalSugestao');
    } catch (erro) {
      this.carregandoService.esconde('buscarPremissaCalcValorFinalSugestao');
      this.notificacaoService.erro(erro);
    }
  }

  async buscarPremissaVisualizacaoKitFechado() {
    try {
      this.carregandoService.mostra('buscarPremissaVisualizacaoKitFechado');

      this.visualizacaoSelecionada = (await this.premissasService.consultarVisualizacaoKitFechado().toPromise()).valor;

      this.carregandoService.esconde('buscarPremissaVisualizacaoKitFechado');
    } catch (erro) {
      this.carregandoService.esconde('buscarPremissaVisualizacaoKitFechado');
      this.notificacaoService.erro(erro);
    }
  }

  buscarPremissaVendaProgramada() {
    this.carregandoService.mostra('buscarPremissaVendaProgramada');
    this.premissasService.consultarVendaProgramada().subscribe(
      (f) => {
        if (f.valor) {
          this.vendaProgramada = true;
        }

        this.carregandoService.esconde('buscarPremissaVendaProgramada');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissaVendaProgramada');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissaUsarAcrescimo() {
    this.carregandoService.mostra('buscarPremissaUsarAcrescimo');
    this.premissasService.consultarUsarAcrescimo().subscribe(
      (f) => {
        if (f.valor) {
          this.pUsarAcrescimo = true;
        }

        this.carregandoService.esconde('buscarPremissaUsarAcrescimo');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissaUsarAcrescimo');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarAdicionarVariosKitPronto() {
    this.carregandoService.mostra('buscarAdicionarVariosKitPronto');
    this.premissasService.consultarAdicionarVariosKitPronto().subscribe(
      (f) => {
        if (f.valor) {
          this.adicionarVariosKitPronto = true;
        }

        this.carregandoService.esconde('buscarAdicionarVariosKitPronto');
      },
      (erro) => {
        this.carregandoService.esconde('buscarAdicionarVariosKitPronto');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarIntPodeAlterarCD() {
    this.carregandoService.mostra('buscarIntPodeAlterarCD');
    this.premissasService.consultarIntPodeAlterarCD().subscribe(
      (f) => {
        this.intPodeAlterarCD = f.valor;

        if (this.intPodeAlterarCD) {
          this.buscarMostrarMsgTrocaCD();
        }

        this.carregandoService.esconde('buscarIntPodeAlterarCD');
      },
      (erro) => {
        this.carregandoService.esconde('buscarIntPodeAlterarCD');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMostrarMsgTrocaCD() {
    this.carregandoService.mostra('buscarMostrarMsgTrocaCD');
    this.premissasService.consultarMostrarMsgTrocaCD().subscribe(
      (f) => {
        this.mostrarMsgTrocaCD = f;
        this.carregandoService.esconde('buscarMostrarMsgTrocaCD');
      },
      (erro) => {
        this.carregandoService.esconde('buscarMostrarMsgTrocaCD');
        this.notificacaoService.erro(erro);
      }
    );
  }

  async buscarMostrarKitPronto() {
    try {
      this.carregandoService.mostra('buscarMostrarKitPronto');

      if (!(await this.segmentacaoService.consultarMostrarKitPronto().toPromise()).valor) {
        this.router.navigate(['/']);
      }

      this.carregandoService.esconde('buscarMostrarKitPronto');
    } catch (erro) {
      this.carregandoService.esconde('buscarMostrarKitPronto');
      this.notificacaoService.erro(erro);
    }
  }

  async buscarPremissaCentroDeDistribuicao() {
    try {
      this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');

      this.pCentroDistribuicao = (await this.premissasService.consultarCentroDeDistribuicao().toPromise()).valor;

      if (this.pCentroDistribuicao) {
        this.buscarIntPodeAlterarCD();
        this.buscarCDs();
      }

      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
    } catch (erro) {
      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
      this.notificacaoService.erro(erro);
    }
  }

  buscarUsarTelhadoCeramico() {
    this.carregandoService.mostra('consultarEstruturasPersonalizadas');
    this.premissasService.consultarEstruturasPersonalizadas().subscribe(
      (dados) => {
        this.estruturasPersonalizadas = dados;

        this.carregandoService.mostra('consultarUsarTelCeramico');
        this.premissasService.consultarUsarTelCeramico().subscribe(
          (f) => {
            this.telhados = [];

            if (f.valor) {
              this.telhados = [
                ...[
                  { id: 11, nome: 'Sem Estrutura' },
                  { id: 0, nome: 'Cerâmico' },
                  { id: 1, nome: 'Fibrocimento' },
                  { id: 8, nome: this.estruturasPersonalizadas.textoFibrometal },
                  { id: 4, nome: 'Metálico' },
                  { id: 7, nome: 'Mini trilho ' },
                  { id: 5, nome: 'Laje' },
                  { id: 6, nome: 'Solo' }
                ]
              ];
            } else {
              this.telhados = [
                ...[
                  { id: 11, nome: 'Sem Estrutura' },
                  { id: 9, nome: 'Colonial' },
                  { id: 10, nome: 'Romana/Americana' },
                  { id: 1, nome: 'Fibrocimento' },
                  { id: 8, nome: this.estruturasPersonalizadas.textoFibrometal },
                  { id: 4, nome: 'Metálico' },
                  { id: 7, nome: 'Mini trilho ' },
                  { id: 5, nome: 'Laje' },
                  { id: 6, nome: 'Solo' }
                ]
              ];
            }

            if (this.estruturasPersonalizadas.usarEstruturaCalhetao) {
              this.telhados.push({ id: 12, nome: this.estruturasPersonalizadas.textoEstruturaCalhetao });
            }

            if (this.estruturasPersonalizadas.usarEstruturaCarport) {
              this.telhados.push({ id: 13, nome: this.estruturasPersonalizadas.textoEstruturaCarport });
            }

            this.carregandoService.esconde('consultarUsarTelCeramico');
          },
          (erro) => {
            this.carregandoService.esconde('consultarUsarTelCeramico');
            this.notificacaoService.erro(erro);
          }
        );

        this.carregandoService.esconde('consultarEstruturasPersonalizadas');
      },
      (erro) => {
        this.carregandoService.esconde('consultarEstruturasPersonalizadas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  listarMarcasPainel() {
    this.carregandoService.mostra('listarMarcasPainel');

    this.marcaService.listarPorFamilia(2, null, true).subscribe(
      (marcs) => {
        this.marcasPainel = marcs;
        this.carregandoService.esconde('listarMarcasPainel');
      },
      (erro) => {
        this.carregandoService.esconde('listarMarcasPainel');
        this.notificacaoService.erro(erro);
      }
    );
  }

  listarMarcasInversor() {
    this.carregandoService.mostra('listarMarcasInversor');

    this.marcaService.listarPorFamilia(3, null, true).subscribe(
      (marcs) => {
        this.marcasInversor = marcs;
        this.carregandoService.esconde('listarMarcasInversor');
      },
      (erro) => {
        this.carregandoService.esconde('listarMarcasInversor');
        this.notificacaoService.erro(erro);
      }
    );
  }

  abrirKit(kit: any) {
    kit.kitAberto = true;
  }

  alterarVisualizacao(visualizacao: number) {
    const buscarProdutos =
      (this.visualizacaoSelecionada === 2 && visualizacao !== 2) ||
      (this.visualizacaoSelecionada !== 2 && visualizacao === 2);

    this.visualizacaoSelecionada = visualizacao;

    if (buscarProdutos) {
      this.lojaProdutos ? this.buscarProdutosLoja() : this.buscarProdutos();
    }
  }

  pesquisarCliente() {
    const dialogRef = this.dialog.open(ClientesModalComponent, {
      width: $('body').width().toString() + 'px',
      data: {
        gi: 1,
        esconderBotao: true
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: { cliente: Cliente; vendedor: any; limDesc: any }) => {
      if (result) {
        this.descontoFrete = result.cliente.descFrete;
        this.cliente = result.cliente;
        this.clienteIntegrador = result.cliente;
        this.descontoMaximo = this.usuarioLogado.limDesc;

        if (this.premissasSistema.habilitarCDPorCidade) {
          this.cliente.idCD = null;
        }

        this.vendedor = result.vendedor;
        this.limDesc = result.limDesc;

        if (this.premissasSistema.usarPrecificacaoPorUF) {
          if (!this.pCentroDistribuicao || (this.pCentroDistribuicao && !this.premissasSistema.habilitarCDPorCidade)) {
            this.estadoSelecionado = this.cliente.uf;
            this.cidadeSelecionado = this.cliente.ibge;

            this.descAcresPrecificacaoUF = this.precificacoesUF.some((p) => p.uf === this.estadoSelecionado)
              ? this.precificacoesUF.find((p) => p.uf === this.estadoSelecionado)
              : { percentual: 0, uf: '', tipoDa: 0 };
          }
        }

        this.buscarCidades();

        if (this.pCentroDistribuicao || this.calcValorFinalSugestao) {
          this.lojaProdutos ? this.buscarProdutosLoja() : this.buscarTodos();
          if (this.itens !== null && this.itens !== null && this.itens.length > 0) {
            this.itens.forEach(async (p) => await this.atualizaValorProduto(p));
          }
        }
      }
    });
  }

  validarIntegradorCentroDistribuicao() {
    if (!this.cliente) {
      swal({
        title: 'Atenção!!',
        text: 'Selecione um integrador para continuar...',
        type: 'warning',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonClass: 'btn btn-danger',
        cancelButtonText: 'Fechar',
        buttonsStyling: false
      }).then(() => {
        this.itensFiltrados = [];
        this.itens = [];
        this.kitsFechadosFiltrados = [];
        return false;
      });
    } else {
      if (!this.cliente.idCD) {
        if (this.premissasSistema.habilitarCDPorCidade) {
          this.itensFiltrados = [];
          this.itens = [];
          this.kitsFechadosFiltrados = [];
          return false;
        } else {
          swal({
            title: 'Atenção!!',
            text: 'Cadastro do integrador incompleto falta (Centro de Distribuição), atualize!',
            type: 'warning',
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonClass: 'btn btn-danger',
            cancelButtonText: 'Fechar',
            buttonsStyling: false
          }).then(() => {
            this.itensFiltrados = [];
            this.itens = [];
            this.kitsFechadosFiltrados = [];
            return false;
          });
        }
      } else {
        return true;
      }
    }
  }

  async calcularValorFinal(valor: number, potencia: number) {
    try {
      this.carregandoService.mostra('buscarPremissaCalcValorFinalSugestao');

      return await this.pedidoService
        .calcularValorFinal(
          !this.integrador
            ? this.cliente !== null && this.cliente !== undefined
              ? this.cliente.id
              : null
            : this.usuarioLogado.id,
          1,
          valor,
          this.cliente && this.pCentroDistribuicao ? this.cliente.idCD : undefined,
          potencia / 1000,
          false,
          null,
          null,
          this.cidadeSelecionado
        )
        .toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissaCalcValorFinalSugestao');
    }
  }

  substituirVirgulaPorPonto(valor) {
    return valor.toString().replace(/,/g, '.');
  }

  buscarProdutosLoja() {
    if (!this.integrador && this.pCentroDistribuicao && !this.validarIntegradorCentroDistribuicao()) {
      this.categoriasMenuLateral = [];
      return;
    }

    const vm = {
      camposPersonalizados: this.categoriasMenuLateral,
      paginaAtual: this.paginacao.paginaAtual,
      itensPorPagina: this.itensPorPagina,
      ordenarPor: 'pesoliq,precovenda',
      ordenarDesc: this.ordenarDesc ? 'desc' : 'asc',
      idCD: this.cliente && this.pCentroDistribuicao ? this.cliente.idCD : undefined,
      idCliente: this.integrador
        ? this.usuarioLogado.id
        : this.cliente !== null && this.cliente !== undefined
          ? this.cliente.id
          : null,
      classificacaoMenu: this.menuProdutoSelecionado ? this.menuProdutoSelecionado.campoPersonalizado : null,
      mostrarFiltroFaixaPreco: this.menuProdutoSelecionado
        ? this.menuProdutoSelecionado.mostrarFiltroFaixaPreco
        : false,
      mostrarFiltroMarca: this.menuProdutoSelecionado ? this.menuProdutoSelecionado.mostrarFiltroMarca : false,
      faixaPreco: {
        min: Number(this.substituirVirgulaPorPonto(this.faixaPreco.min)),
        max: Number(this.substituirVirgulaPorPonto(this.faixaPreco.max))
      },
      marcasSelecionadas: [...this.marcasProdutoSelecionadas]
    };

    this.carregandoService.mostra('buscarProdutosLoja');
    this.produtoService.consultarProdutosLoja(vm).subscribe(
      (result) => {
        let produtos = result.itens;
        this.itensFiltrados = [];
        this.marcasProduto = result.marcas;

        produtos.forEach((p) => {
          const novoItem = new ItemPedido();
          novoItem.pUnitario = p.precoVenda;
          novoItem.pCusto = p.precoCusto;
          novoItem.produto = p.idProduto;
          novoItem.produtoTela = p;
          novoItem.det1 = p.descricaoAtual;
          novoItem.pVendaOriginal = novoItem.pUnitario;

          if (
            this.calcValorFinalSugestao &&
            (this.integrador || (this.cliente !== null && this.cliente !== undefined))
          ) {
            novoItem.pUnitarioSugerido = p.precoFinalSugerido;
          }

          if (p.multiplo && p.valorMultiplo > 0) {
            novoItem.qt = p.valorMultiplo;
          }

          this.itensFiltrados.push(novoItem);
        });

        this.itensFiltrados.forEach((kit: ItemPedido) => {
          kit.imagem$ = this.buscarImagemProduto(kit.produtoTela);
          kit.imagem$.then((p) => {
            kit.buscouImagem = true;
          });
        });

        this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(result.total);

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = result.total;

        this.carregandoService.esconde('buscarProdutosLoja');
      },
      (erro) => {
        this.carregandoService.esconde('buscarProdutosLoja');
        this.notificacaoService.erro(erro);
      }
    );
  }

  async buscarVendPodeAlterarCD() {
    try {
      this.carregandoService.mostra('buscarVendPodeAlterarCD');
      this.vendPodeAlterarCD = await this.funcionarioService.consultaPodeAlterarCD().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarVendPodeAlterarCD');
    }
  }

  buscarDescricaoCD() {
    if (
      this.cliente &&
      this.cliente.idCD !== null &&
      this.cliente.idCD !== undefined &&
      this.cds &&
      this.cds.some((p) => p.id === this.cliente.idCD)
    ) {
      return this.cds.find((p) => p.id === this.cliente.idCD).descricao;
    } else {
      return '';
    }
  }

  buscarProdutos() {
    if (!this.integrador && this.pCentroDistribuicao && !this.validarIntegradorCentroDistribuicao()) return;

    if (this.pCentroDistribuicao && (this.cliente.idCD === null || this.cliente.idCD === undefined)) return;

    this.gerarLogAcesso();

    this.carregandoService.mostra('buscaProduto');
    this.carregando = true;

    if (this.visualizacaoSelecionada !== 2) {
      this.produtoService
        .consultarComPaginacao(
          this.paginacao.paginaAtual,
          this.itensPorPagina,
          'pesoliq,precovenda',
          this.ordenarDesc ? 'desc' : 'asc',
          null,
          '',
          'A',
          '7',
          true,
          null,
          null,
          null,
          this.potenciaParaFiltrar ? this.potenciaParaFiltrar * 1000 : undefined,
          this.potMax ? this.potMax * 1000 : undefined,
          this.cliente && this.pCentroDistribuicao ? this.cliente.idCD : undefined,
          this.multiFornecedores,
          this.idProduto ? this.idProduto : null,
          this.marcaPainelSelecionada,
          this.marcaInversorSelecionada,
          this.telhadoSelecionado,
          this.ordenacaoSelecionada,
          null,
          null,
          null,
          null,
          true,
          this.integrador
            ? this.usuarioLogado.id
            : this.cliente !== null && this.cliente !== undefined
              ? this.cliente.id
              : null,
          null,
          null,
          null,
          'A',
          this.menuOrigem
        )
        .subscribe(
          async (dados) => {
            const produtos: Produto[] = dados.itens;

            this.itensFiltrados = [];
            this.kitsFechadosFiltrados = [];

            produtos.forEach((p) => {
              const novoItem = new ItemPedido();
              novoItem.pUnitario = p.precoVenda;
              novoItem.pCusto = p.precoCusto;
              novoItem.produto = p.idProduto;
              novoItem.produtoTela = p;
              novoItem.det1 = p.descricaoAtual;
              novoItem.pVendaOriginal = novoItem.pUnitario;

              if (
                this.calcValorFinalSugestao &&
                (this.integrador || (this.cliente !== null && this.cliente !== undefined))
              ) {
                novoItem.pUnitarioSugerido = p.precoFinalSugerido;
              }

              this.itensFiltrados.push(novoItem);
            });

            this.itensFiltrados.forEach((kit: ItemPedido) => {
              kit.imagem$ = this.buscarImagemProduto(kit.produtoTela);
              kit.imagem$.then((p) => {
                kit.buscouImagem = true;
              });
            });

            this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(dados.total);

            if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
              this.itensPorPagina = 10;
            }

            this.paginacao.total = dados.total;

            if (this.idProduto) {
              if (this.itensFiltrados.length > 0) {
                this.itensFiltrados[0].qt = 1;
                this.itens = this.itensFiltrados;

                await this.atualizaValorProduto(this.itens[0]);
              }

              this.idProduto = undefined;
            }

            this.carregando = false;
            this.carregandoService.esconde('buscaProduto');
          },
          () => {
            this.carregandoService.esconde('buscaProduto');
          }
        );
    } else {
      this.produtoService
        .consultarKitFechadoComPaginacao(
          this.paginacao.paginaAtual,
          this.itensPorPagina,
          'pesoliq,precovenda',
          this.ordenarDesc ? 'desc' : 'asc',
          null,
          '',
          'A',
          '7',
          false,
          null,
          null,
          null,
          this.potenciaParaFiltrar ? this.potenciaParaFiltrar * 1000 : undefined,
          this.potMax ? this.potMax * 1000 : undefined,
          this.cliente && this.pCentroDistribuicao ? this.cliente.idCD : undefined,
          this.multiFornecedores,
          this.idProduto ? this.idProduto : null,
          this.marcaPainelSelecionada,
          this.marcaInversorSelecionada,
          this.telhadoSelecionado,
          this.ordenacaoSelecionada,
          null,
          null,
          null,
          null,
          true,
          this.integrador
            ? this.usuarioLogado.id
            : this.cliente !== null && this.cliente !== undefined
              ? this.cliente.id
              : null,
          this.menuOrigem
        )
        .subscribe(
          async (dados) => {
            this.itensFiltrados = [];
            this.kitsFechadosFiltrados = dados.itens;

            this.kitsFechadosFiltrados.forEach((k) => {
              k.itens = [];

              k.produtos.forEach((p) => {
                const novoItem = new ItemPedido();
                novoItem.pUnitario = p.precoVenda;
                novoItem.pCusto = p.precoCusto;
                novoItem.produto = p.idProduto;
                novoItem.produtoTela = p;
                novoItem.det1 = p.descricaoAtual;
                novoItem.pVendaOriginal = novoItem.pUnitario;

                if (
                  this.calcValorFinalSugestao &&
                  (this.integrador || (this.cliente !== null && this.cliente !== undefined))
                ) {
                  novoItem.pUnitarioSugerido = p.precoFinalSugerido;
                }

                k.itens.push(novoItem);
              });

              k.imagemMarcaPainel$ = this.arquivoService
                .baixarArquivo(k.idMarcaPainel, TipoArquivo.Marca)
                .map((m) =>
                  m !== null && m !== undefined
                    ? this.utilitarioService.toBase64ComInicio(m)
                    : Promise.resolve('./assets/img/sem-foto-w.jpg')
                )
                .toPromise();
              k.imagemMarcaPainel$
                .then((p) => {
                  k.buscouImagemMarcaPainel = true;
                })
                .catch((erro) => {
                  k.buscouImagemMarcaPainel = true;
                  k.imagemMarcaPainel$ = Promise.resolve('./assets/img/sem-foto-w.jpg');
                });

              k.imagemMarcaInversor$ = this.arquivoService
                .baixarArquivo(k.idMarcaInversor, TipoArquivo.Marca)
                .map((m) =>
                  m !== null && m !== undefined
                    ? this.utilitarioService.toBase64ComInicio(m)
                    : Promise.resolve('./assets/img/sem-foto-w.jpg')
                )
                .toPromise();
              k.imagemMarcaInversor$
                .then((p) => {
                  k.buscouImagemMarcaInversor = true;
                })
                .catch((erro) => {
                  k.buscouImagemMarcaInversor = true;
                  k.imagemMarcaInversor$ = Promise.resolve('./assets/img/sem-foto-w.jpg');
                });
            });

            this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(dados.total);

            if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
              this.itensPorPagina = 10;
            }

            this.paginacao.total = dados.total;

            if (this.idProduto) {
              if (this.kitsFechadosFiltrados.length > 0) {
                this.kitsFechadosFiltrados[0].itens[0].qt = 1;

                this.itens = this.kitsFechadosFiltrados[0].itens;
                await this.atualizaValorProduto(this.itens[0]);
              }

              this.idProduto = undefined;
            }

            this.carregando = false;
            this.carregandoService.esconde('buscaProduto');
          },
          () => {
            this.carregandoService.esconde('buscaProduto');
          }
        );
    }
  }

  async buscarImagemProduto(produto: Produto): Promise<string> {
    const imagem = await this.produtoService.consultarImagemProdutoPorId(produto.idProduto).toPromise();

    if (imagem && imagem.url) {
      return Promise.resolve(imagem.url);
    } else if (imagem && imagem.raw) {
      return Promise.resolve('data:image/jpg;base64,' + imagem.raw);
    } else {
      return Promise.resolve('./assets/img/inversor.png');
    }
  }

  rolarParaFimDaPagina() {
    const element = document.getElementById('tabelaItensSelecionados');

    element.scrollIntoView();
  }

  async selecionarProduto(produto?) {
    this.rolarParaFimDaPagina();

    const produtoNaLista = this.itens.find((p) => p.produtoTela.idProduto === produto.produtoTela.idProduto);

    if (produtoNaLista) {
      produtoNaLista.qt++;
      await this.atualizaValorProduto(produtoNaLista);
    } else {
      if (produto.produtoTela.multiplo && produto.produtoTela.valorMultiplo > 0) {
        produto.qt = produto.produtoTela.valorMultiplo;
      } else {
        produto.qt = 1;
      }

      produto.pVendaOriginal = produto.pUnitario;
      this.itens = [...this.itens, produto];
      await this.atualizaValorProduto(
        this.itens.find((p) => p.produtoTela.idProduto === produto.produtoTela.idProduto)
      );
    }
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.lojaProdutos ? this.buscarProdutosLoja() : this.buscarProdutos();
  }

  gerarLogAcesso() {
    const logAcesso: LogAcesso = {
      tipo: TipoDeLogAcesso.KitPronto,
      potenciaDe: this.potenciaParaFiltrar ? Number(this.potenciaParaFiltrar) : undefined,
      potenciaAte: this.potMax ? Number(this.potMax) : undefined
    };

    this.logAcessoService.Salvar(logAcesso).subscribe(() => {});
  }

  // abre o modal de pesquisa de produtos
  pesquisarProdutos(potencia?) {
    const dialogRef = this.dialog.open(SelecionaKitModalComponent, {
      width: $('body').width().toString() + 'px',
      // passa os produtos já selecionados
      data: {
        itens: this.itens,
        potTotal: potencia ? potencia : this.potTotal,
        potenciaAte: this.potMax ? this.potMax : potencia,
        multiFornecedores: this.multiFornecedores,
        idProduto: this.idProduto
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    // quando fecha o modal
    dialogRef.afterClosed().subscribe((result: ItemPedido[]) => {
      this.idProduto = undefined;

      if (result) {
        // verifica se é para excluir algum item
        if (this.itens.some((p) => !result.some((r) => r.produtoTela.idProduto === p.produtoTela.idProduto))) {
          this.itens
            .filter((p) => !result.some((r) => r.produtoTela.idProduto === p.produtoTela.idProduto))
            .forEach((it) => {
              this.excluirProduto(it);
            });
        }

        if (result.some((p) => p.produtoTela.familia === 2)) {
        } else {
          // atualiza a lista de produtos
          result.forEach(async (p) => {
            if (this.itens.some((ps) => ps.produtoTela.idProduto === p.produtoTela.idProduto)) {
              this.itens.find((ps) => ps.produtoTela.idProduto === p.produtoTela.idProduto).qt = p.qt;
              await this.atualizaValorProduto(
                this.itens.find((ps) => ps.produtoTela.idProduto === p.produtoTela.idProduto)
              );
            } else {
              this.itens.push(p);
              this.ordenaProdutos();
              await this.atualizaValorProduto(p);
            }
          });
        }
      }
    });
  }

  excluirProduto(item: ItemPedido) {
    this.itens.splice(this.itens.indexOf(item), 1);

    if (
      this.descontosDoProduto.some(
        (p) =>
          p.produto === item.produtoTela.idProduto &&
          Number(item.qt) >= Number(p.qtdIni) &&
          Number(item.qt) <= Number(p.qtdFim)
      )
    ) {
      this.descontoParaAplicar.valor = 0;
      this.descontosDoProduto = [];
      this.itens.forEach(async (p) => {
        if (p.produtoTela.idProduto !== item.produtoTela.idProduto) {
          await this.atualizaValorProduto(p);
        }
      });
    }

    this.atualizaValores();
  }

  async atualizaValorProduto(item: ItemPedido) {
    if (
      this.descontosDoProduto.some(
        (p) =>
          p.produto === item.produtoTela.idProduto &&
          Number(item.qt) >= Number(p.qtdIni) &&
          Number(item.qt) <= Number(p.qtdFim)
      )
    ) {
      this.descontoParaAplicar.valor = this.descontosDoProduto.find(
        (p) =>
          p.produto === item.produtoTela.idProduto &&
          Number(item.qt) >= Number(p.qtdIni) &&
          Number(item.qt) <= Number(p.qtdFim)
      ).desco;

      this.descontoParaAplicar.fornecedor = item.produtoTela.fornecedor;
      this.descontoParaAplicar.idProduto = item.produto;

      if (this.aplicacaoDescontoProgressivo === 0) {
        this.itens.forEach(async (p) => {
          if (p.produtoTela.idproduto !== item.produtoTela.idProduto) {
            await this.atualizaValorProduto(p);
          }
        });
      }
    } else if (
      this.descontoParaAplicar.valor !== 0 &&
      this.descontosDoProduto.some((p) => p.produto === item.produtoTela.idProduto) &&
      !this.descontosDoProduto.some(
        (p) =>
          p.produto === item.produtoTela.idProduto &&
          Number(item.qt) >= Number(p.qtdIni) &&
          Number(item.qt) <= Number(p.qtdFim)
      )
    ) {
      this.descontoParaAplicar.valor = 0;
      this.descontoParaAplicar.idProduto = item.produto;

      if (this.aplicacaoDescontoProgressivo === 0) {
        this.itens.forEach(async (p) => {
          if (p.produtoTela.idproduto !== item.produtoTela.idProduto) {
            await this.atualizaValorProduto(p);
          }
        });
      }
    }

    item.pUnitario =
      item.produto === this.descontoParaAplicar.idProduto || this.aplicacaoDescontoProgressivo === 0
        ? item.produtoTela.precoVenda - (item.produtoTela.precoVenda * this.descontoParaAplicar.valor) / 100
        : item.produtoTela.precoVenda;

    if (this.premissasSistema.usarPrecificacaoPorUF) {
      item.pUnitario = this.calcularPrecificacaoUF(item.pUnitario, this.descAcresPrecificacaoUF);
    }

    item.vTotal = item.pUnitario * item.qt;

    if (this.calcValorFinalSugestao && (this.integrador || (this.cliente !== null && this.cliente !== undefined))) {
      item.vTotalSugerido = await this.calcularValorFinal(item.pUnitario * item.qt, Number(item.produtoTela.potencia));
    }

    this.atualizaValores();
  }

  // atualiza os totais
  atualizaValores() {
    let valortotal = 0;

    //this.itens.forEach((p) => (valortotal += Number(p.vTotal)));

    this.orcamento.valorTotal = Number(
      this.itens.reduce((acc, curr) => acc + Number(curr.pUnitario) * Number(curr.qt), 0).toFixed(2)
    );

    if (this.orcamento.valorDa !== undefined) {
      if (this.orcamento.da === 0) {
        this.orcamento.valorFinal = Number((this.orcamento.valorTotal - this.orcamento.valorDa).toFixed(2));
      } else {
        this.orcamento.valorFinal = Number((this.orcamento.valorTotal + this.orcamento.valorDa).toFixed(2));
      }
    } else {
      this.orcamento.valorFinal = this.orcamento.valorTotal;
    }
    this.calcularPesoBruto();
  }

  ordenaProdutos() {
    this.carregandoService.mostra('ordenaProduto');
    this.itens = this.itens.sort((a, b) => {
      return this.compare(
        this.retornaOrdemTipoProduto(a.produtoTela.familia),
        this.retornaOrdemTipoProduto(b.produtoTela.familia),
        true
      );
    });
    this.carregandoService.esconde('ordenaProduto');
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  retornaOrdemTipoProduto(tipo) {
    switch (tipo) {
      case '7':
        return 0;
      case '2':
        return 1;
      case '3':
        return 2;
      case '4':
        return 3;
      case '5':
        return 4;
      case '6':
        return 5;
      case '1':
        return 6;
      default:
        return 6;
    }
  }
  detalhesDoProduto(produto: Produto) {
    this.dialog.open(DetalheProdutoModalComponent, {
      width: $('body').width().toString() + 'px',
      data: {
        produto: produto
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });
  }

  async aumentaQtdProduto(item: ItemPedido) {
    const incremento =
      item.produtoTela.multiplo && item.produtoTela.valorMultiplo > 0 ? item.produtoTela.valorMultiplo : 1;
    const novaQuantidade = Number(item.qt) + incremento;

    if (novaQuantidade <= 100000) {
      item.qt = novaQuantidade;
      await this.atualizaValorProduto(item);
    }
  }

  async diminuiQtdProduto(item: ItemPedido) {
    const decremento =
      item.produtoTela.multiplo && item.produtoTela.valorMultiplo > 0 ? item.produtoTela.valorMultiplo : 1;
    const novaQuantidade = Number(item.qt) - decremento;

    if (novaQuantidade >= 1) {
      item.qt = novaQuantidade;
      await this.atualizaValorProduto(item);
    }
  }

  async validaQtd(item: ItemPedido) {
    if (item.qt === null || item.qt === undefined || Number.isNaN(Number(item.qt)) || Number(item.qt) < 0) {
      item.qt = 1;
      await this.atualizaValorProduto(item);
    } else if (Number(item.qt) > 100000) {
      item.qt = 100000;
      await this.atualizaValorProduto(item);
    }
  }

  escolhePotencia() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(PotenciaKitsModalComponent, {
      width: largura > 630 ? '600px' : $('body').width().toString() + 'px',
      data: {},
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe((result: number) => {
      if (result) {
        this.potTotal = result;
      }
    });
  }

  buscouPotencia() {
    this.filtrouPotencia = true;
    this.potTotal = this.potMin;
  }

  buscarTodos() {
    this.filtrouPotencia = true;
    this.potMin = 0;
    this.potTotal = this.potMin;
    this.buscarProdutos();
  }

  buscarCliente() {
    this.carregandoService.mostra('buscaClientes');
    this.clienteService.consultarPorIdCliente(this.orcamento.cliente, true).subscribe(
      (cli) => {
        this.cliente = cli;

        if (this.premissasSistema.habilitarCDPorCidade) {
          this.cliente.idCD = null;
        }

        if (this.premissasSistema.usarPrecificacaoPorUF) {
          if (!this.pCentroDistribuicao || (this.pCentroDistribuicao && !this.premissasSistema.habilitarCDPorCidade)) {
            this.estadoSelecionado = this.cliente.uf;
            this.cidadeSelecionado = this.cliente.ibge;

            this.descAcresPrecificacaoUF = this.precificacoesUF.some((p) => p.uf === this.estadoSelecionado)
              ? this.precificacoesUF.find((p) => p.uf === this.estadoSelecionado)
              : { percentual: 0, uf: '', tipoDa: 0 };
          }
        }

        this.buscarCidades();

        this.lojaProdutos ? this.buscarProdutosLoja() : this.buscarTodos();

        this.carregandoService.esconde('buscaClientes');
      },
      (erro) => {
        this.carregandoService.esconde('buscaClientes');
        this.notificacaoService.erro(erro);
      }
    );
  }

  salvarOrcamento(tipo: any) {
    let potTotal = 0;

    if (!this.lojaProdutos) {
      const pPainel = this.itens.find((p) => p.produtoTela.familia === 2 || p.produtoTela.familia === 7);
      const potenciaPainel = pPainel.produtoTela.potencia;
      const quantidadeDePaineis = Number(pPainel.qt);

      potTotal = Number(((potenciaPainel * quantidadeDePaineis) / 1000).toFixed(2));
    }

    let da: number;
    let percentual: number;
    let valorDa: number;

    if (this.calcularDesconto && this.pUsarAcrescimo && this.cliente.daGI === 1) {
      da = 1;
      percentual = this.cliente.acrescimoGI;
      valorDa = Number(((Number(this.orcamento.valorTotal) * this.cliente.acrescimoGI) / 100).toFixed(2));
    }

    let idFornecedor = null;

    if (this.pCentroDistribuicao) {
      idFornecedor = this.cliente.idCD;
    }

    if (this.multiFornecedores && this.orcamento.painelProduto !== null && this.orcamento.painelProduto !== undefined) {
      idFornecedor = this.orcamento.painelProduto.idFornecedor;
    }

    let qtModulos = 0;

    if (this.premissasSistema.usaDescargaCif) {
      qtModulos = this.itens.reduce((total, it) => {
        if (it.produtoTela.familia === 2) {
          return total + it.qt;
        }
        if (it.produtoTela.familia === 7) {
          return (
            total +
            it.produtoTela.composicao.reduce((compTotal, comp) => {
              return comp.produtoMP.familia === 2 ? compTotal + comp.qt * it.qt : compTotal;
            }, 0)
          );
        }
        return total;
      }, 0);
    }

    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(DigitaCampoModalComponent, {
      width: largura > 1030 ? '1000px' : $('body').width().toString() + 'px',
      // passa os produtos já selecionados
      data: {
        origem: this.lojaProdutos ? 3 : 1,
        tipo: tipo,
        selecionarIntegrador: !this.integrador,
        informarNome: !this.nome,

        nome: this.nome,
        descontoFrete: this.descontoFrete,
        cliente: this.cliente,
        clienteIntegrador: this.clienteIntegrador,
        descontoMaximo: this.descontoMaximo,

        valorProdutos: this.orcamento.valorTotal,
        ibge: this.cliente ? this.cliente.ibge : '',
        calculadora: this.calculadora,
        uf: this.estadoSelecionado,
        cidade: this.cidadeSelecionado,
        naoCalcularFrete: !this.calcularFrete,
        naoCalcularDesconto: !this.calcularDesconto,
        idDescarga: this.orcamento.idDescarga,
        limDesc: this.limDesc,
        vendedor: this.vendedor
          ? this.vendedor
          : !this.integrador
            ? { idFuncion: this.usuarioLogado.id, nome: this.usuarioLogado.nome }
            : null,

        idCD: this.pCentroDistribuicao
          ? this.cliente.idCD
          : this.multiFornecedores &&
              this.orcamento.painelProduto !== null &&
              this.orcamento.painelProduto !== undefined
            ? this.orcamento.painelProduto.idFornecedor
            : undefined,
        potencia: potTotal,

        da: da,
        percentual: percentual,
        valorDa: valorDa,
        valorTotalFixo: this.orcamento.valorTotalFixo,
        descAcresPrecificacaoUF: this.descAcresPrecificacaoUF,
        itens: JSON.parse(JSON.stringify(this.itens)),
        idFornecedor: idFornecedor,
        qtModulos: qtModulos
      },
      panelClass: 'modal-card',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.orcamento.comprador = result.nome;
        this.pedidoService.setFormaPagPedido(this.orcamento, result.formaPagamento);
        this.pedidoService.setCondPagPedido(this.orcamento, result.condicaoPagamento);
        if (tipo !== 0) {
          this.orcamento.vendaDireta = result.vendaDireta;
          this.clienteFaturamento = result.clienteFaturamento;
        }

        this.respostas = result.respostas;

        this.itens = JSON.parse(JSON.stringify(result.itens));
        this.descAcresPrecificacaoUF = result.descAcresPrecificacaoUF;
        this.orcamento.valorTotal = result.valorProdutos;

        this.orcamento.obs2 = result.enderecoEntregaCompleto;

        this.orcamento.txLocalizacao = result.txLocalizacao;
        this.orcamento.tipoLocalizacao = result.localizacao;
        this.orcamento.da = result.da;
        this.orcamento.valorDa = Number(result.valorDa);
        this.orcamento.percentual = Number(result.percentual);
        this.orcamento.tipoFrete = Number(result.tipoFrete);
        this.orcamento.frete = Number(result.valorFrete);
        this.orcamento.entrega = Number(result.entrega);
        this.orcamento.taxaDA = Number(result.taxaDA);
        this.enderecoDeEntrega = result.enderecoEntrega;
        this.enderecoDeEntrega.ibge = Number(this.enderecoDeEntrega.ibge);
        this.orcamento.multiFormaPagamento = result.usandoMultiFormasPagamento;

        this.orcamento.impostos = result.impostos;
        this.orcamento.valorImpostos = result.valorImpostos;
        this.orcamento.impostosPendente = result.impostoPendente;

        if (this.lojaProdutos) {
          this.orcamento.origemGI = 3;
        } else {
          this.orcamento.origemGI = 1;
        }

        this.orcamento.idDescarga =
          result.idDescarga === null || result.idDescarga === undefined ? null : Number(result.idDescarga);

        this.orcamento.transportadora = result.idTransportadora;

        this.orcamento.valorServico = Number(result.valorServico);
        this.orcamento.valorServicoLiquido = Number(result.valorLiquido);

        this.orcamento.freteManual = result.freteManual;

        this.orcamento.formasPagamento = result.formasPagamento;

        this.orcamento.seguros = result.seguros;
        this.orcamento.servicoEntrega = result.servicoEntrega;
        this.orcamento.valorServicoEntrega = result.valorServicoEntrega;
        this.orcamento.servicoEntregaManual = result.servicoEntregaManual;

        this.orcamento.valorProjeto = result.valorProjeto;
        this.orcamento.valorProjetoLiquido = result.valorProjetoLiquido;
        this.orcamento.tipoCIF = result.tipoCIF;

        if (!this.integrador) {
          this.orcamento.cliente = result.cliente.id;
        }

        this.orcamento.valorTotalFixo = result.valorTotalFixo;

        this.orcamento.idFrete = result.idFrete;

        this.comprovante = result.comprovante;
        this.confirmar = result.confirmar;

        this.orcamento.voucher = result.voucher;
        this.orcamento.dadosVoucher = result.dadosVoucher;
        this.orcamento.valorVoucher = result.valorVoucher;

        this.salvarPedido(tipo);
      }
    });
  }

  salvarPedido(tipo) {
    this.carregandoService.mostra('salvaPedido');

    const vendedorSelecionado = this.vendedor ? this.vendedor.idFuncion : this.usuarioLogado.id;

    this.orcamento.vendedor = this.integrador ? this.cliente.vendedor : vendedorSelecionado;
    this.orcamento.indicacao = 0;
    this.orcamento.nItens = this.itens.length;
    this.orcamento.troco = 0;
    this.orcamento.nParcelas = 1;
    this.orcamento.gTotal = 0;
    this.orcamento.nCartao = '1';
    this.orcamento.bc = 0;
    this.orcamento.ext = 0;
    this.orcamento.nECF = '0';
    this.orcamento.turno = 0;
    this.orcamento.nTurno = 0;
    this.orcamento.status = 0;
    this.orcamento.nPdv = 98;
    this.orcamento.nLoja = 1;

    this.orcamento.funcDesco = 0;
    this.orcamento.data = new Date();

    if (this.multiFornecedores) {
      this.orcamento.idFornecedor = this.itens[0].produtoTela.idFornecedor;
    }

    if (this.pCentroDistribuicao) {
      this.orcamento.idFornecedor = this.cliente.idCD;
    }

    this.itens.forEach((it) => {
      it.nItem = this.itens.indexOf(it) + 1;
      it.cc = it.produtoTela.cc;
      it.comissao = 0;
      it.da = 0; // se tiver desconto é 0
      it.valorDa = 0;
      it.frete = 0;
      it.pCusto = it.produtoTela.precoCusto;
      it.percentual = 0;
      it.idCupom = this.idOrcamento ? this.idOrcamento : it.idCupom;
    });
    this.salvar(tipo);
  }

  salvar(tipo) {
    this.itens.forEach((p) => {
      p.pVendaOriginal = p.produtoTela.precoVenda;
    });

    if (tipo === 1 && this.confirmar) {
      this.pedidoService
        .confirmarOrcamento(
          this.orcamento,
          this.itens,
          [],
          this.orcamento.vendaDireta ? this.clienteFaturamento : null,
          false,
          tipo === 0 ? true : false,
          false,
          this.enderecoDeEntrega,
          this.comprovante,
          this.respostas
        )
        .subscribe(
          (resp: any) => {
            this.idOrcamento = resp.idCupom;
            this.carregandoService.esconde('salvaPedido');
            this.notificacaoService.sucesso('Pedido Confirmado com sucesso!!!');
            this.router.navigate(['/pedidos']);
          },
          (erro) => {
            this.carregandoService.esconde('salvaPedido');
            this.notificacaoService.erro(erro);

            this.definirItemSemLote(erro);
          }
        );
    } else {
      this.pedidoService
        .salvar(
          this.orcamento,
          this.itens,
          [],
          this.orcamento.vendaDireta ? this.clienteFaturamento : null,
          false,
          tipo === 0 ? true : false,
          false,
          this.enderecoDeEntrega,
          this.respostas
        )
        .subscribe(
          (resp: any) => {
            this.idOrcamento = resp.idCupom;
            this.notificacaoService.sucesso((tipo === 0 ? 'Orçamento' : 'Pedido') + ' Salvo com sucesso!!!');
            this.carregandoService.esconde('salvaPedido');
            this.router.navigate([tipo === 0 ? '/orcamentos' : '/pedidos']);
          },
          (erro) => {
            this.carregandoService.esconde('salvaPedido');
            this.notificacaoService.erro(erro);
            this.definirItemSemLote(erro);
          }
        );
    }
  }

  definirItemSemLote(erro) {
    this.itemSemLote = false;

    if (this.vendaProgramada && erro.error && erro.error.itemSemLote) {
      this.itemSemLote = true;

      this.itens.forEach((p) => {
        p.produtoTela.semLote = false;

        if (p.produto === erro.error.itemSemLote) {
          p.produtoTela.semLote = true;
        } else if (p.produtoTela.composicao) {
          p.produtoTela.composicao.forEach((c) => {
            c.produtoMP.semLote = false;
            if (c.proMP === erro.error.itemSemLote) {
              p.produtoTela.semLote = true;
              c.produtoMP.semLote = true;
            }
          });
        }
      });
    }
  }

  validarPotencias(tipo: number) {
    const isNullOrUndefined = (value: any) => value === null || value === undefined;

    if (tipo === 0) {
      if (!isNullOrUndefined(this.potenciaParaFiltrar) && !isNullOrUndefined(this.potMax)) {
        if (Number(this.potenciaParaFiltrar) > Number(this.potMax)) {
          this.notificacaoService.erro('A Potência De deve ser menor que a Potência Até.');
          this.potMax = this.potenciaParaFiltrar;
        }
      }
    } else if (tipo === 1) {
      if (!isNullOrUndefined(this.faixaPreco.min) && !isNullOrUndefined(this.faixaPreco.max)) {
        if (Number(this.faixaPreco.min) > Number(this.faixaPreco.max)) {
          this.notificacaoService.erro('A faixa de preço mínimo deve ser menor que a faixa de preço máximo.');
          this.faixaPreco.max = Number(this.faixaPreco.min);
        }
      }
    }
  }

  calcularPesoBruto() {
    this.pesoBruto = 0;
    this.itens.forEach((element: any) => {
      this.pesoBruto += element.produtoTela.peso ? element.produtoTela.peso * element.qt : 0;
    });
  }

  async buscarMultiFornecedores() {
    try {
      this.carregandoService.mostra('buscarMultiFornecedores');

      this.multiFornecedores = (await this.premissasService.consultarMultiFornecedores().toPromise()).valor;

      this.carregandoService.esconde('buscarMultiFornecedores');
    } catch (erro) {
      this.carregandoService.esconde('buscarMultiFornecedores');
      this.notificacaoService.erro(erro);
    }
  }

  buscarMostrarDescKit() {
    this.carregandoService.mostra('buscarMostrarDescKit');
    this.premissasService.consultarMostrarDescKit().subscribe(
      (f) => {
        this.mostrarDescKit = f.valor;
        this.carregandoService.esconde('buscarMostrarDescKit');
      },
      (erro) => {
        this.carregandoService.esconde('buscarMostrarDescKit');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarKitProntoFreteDesconto() {
    this.carregandoService.mostra('buscarKitProntoFrete');
    this.premissasService.consultarKitProntoFrete().subscribe(
      (f) => {
        this.calcularFrete = f.valor;
        this.carregandoService.esconde('buscarKitProntoFrete');
      },
      (erro) => {
        this.carregandoService.esconde('buscarKitProntoFrete');
        this.notificacaoService.erro(erro);
      }
    );

    this.carregandoService.mostra('buscarKitProntoDesconto');
    this.premissasService.consultarKitProntoDesconto().subscribe(
      (f) => {
        this.calcularDesconto = f.valor;
        this.carregandoService.esconde('buscarKitProntoDesconto');
      },
      (erro) => {
        this.carregandoService.esconde('buscarKitProntoDesconto');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarCDs() {
    this.carregandoService.mostra('buscarCDs');

    this.fornecedorService.consultarFornecedores().subscribe(
      (forn) => {
        this.cds = forn;
        this.carregandoService.esconde('buscarCDs');
      },
      (err) => {
        this.carregandoService.esconde('buscarCDs');
        this.notificacaoService.erro(err);
      }
    );
  }

  trocarCD() {
    if (this.itens === null || this.itens === undefined || this.itens.length === 0) {
      return;
    }

    this.carregandoService.mostra('trocarCD');
    this.carregando = true;

    this.produtoService.trocarCD(this.itens.map((p) => p.produto).join(','), true, this.cliente.idCD, '7').subscribe(
      (dados) => {
        const produtos: Produto[] = dados;

        const itensAtualizados: ItemPedido[] = [];

        produtos.forEach((p) => {
          const novoItem = this.itens.find((i) => i.produto === p.idProduto);
          novoItem.pUnitario = p.precoVenda;
          novoItem.pCusto = p.precoCusto;
          novoItem.produto = p.idProduto;
          novoItem.produtoTela = p;
          novoItem.det1 = p.descricaoAtual;
          novoItem.pVendaOriginal = novoItem.pUnitario;

          itensAtualizados.push(novoItem);
        });

        this.itens = [...itensAtualizados];

        this.itens.forEach(async (i) => await this.atualizaValorProduto(i));

        this.carregando = false;
        this.carregandoService.esconde('trocarCD');
      },
      () => {
        this.carregandoService.esconde('trocarCD');
      }
    );
  }

  buscarMenuProduto() {
    this.carregandoService.mostra('buscarmenu');

    this.menuProdutoService.consultarMenuProdutos().subscribe(
      (result) => {
        this.menusProduto = result;

        this.menusProduto.forEach((m) => (m.esconderFilhos = true));

        this.carregandoService.esconde('buscarmenu');
      },
      (error) => {
        this.notificacaoService.erro(error);
        this.carregandoService.esconde('buscarmenu');
      }
    );
  }

  async buscarCamposPersonalizados() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarCamposPersonalizados');

      this.campoPersonalizadoService.consultarTodosProdutoCampoPersonalizado().subscribe(
        (campos) => {
          this.camposPersonalizados = campos;
          this.carregandoService.esconde('buscarCamposPersonalizados');
          resolve();
        },
        (erro) => {
          this.carregandoService.esconde('buscarCamposPersonalizados');
          this.notificacaoService.erro(erro);
          reject();
        }
      );
    });
  }

  limparFiltros() {
    this.categoriasMenuLateral.forEach((p) => {
      p.itensSelecionados = [];
      p.itemSelecionado = undefined;
      p.textoSelecionado = '';
    });

    this.faixaPreco = {
      min: 0,
      max: 0
    };

    this.marcasProdutoSelecionadas = new Set<number>();

    this.buscarProdutosLoja();
  }

  selecionarMenuProduto(menu: MenuProduto) {
    this.menuProdutoSelecionado = menu;

    this.categoriasMenuLateral = this.camposPersonalizados.filter((c) =>
      menu.categoriasMenuLateral.some((cp) => cp === c.id)
    );

    this.itensFiltrados = [];

    this.limparFiltros();

    this.buscarProdutosLoja();
  }

  abrirMenuProduto(menu: MenuProduto) {
    menu.esconderFilhos = false;

    this.menusProduto.forEach((m) => {
      if (m.idMenu != menu.idMenu) {
        // m.esconderFilhos = true;
      }
    });
  }

  onCheckboxMarcaChange(event: MatCheckboxChange, itemId: number) {
    if (event.checked) {
      this.marcasProdutoSelecionadas.add(itemId);
    } else {
      this.marcasProdutoSelecionadas.delete(itemId);
    }
    this.buscarProdutosLoja();
  }

  isMarcaSelected(itemId: number): boolean {
    return this.marcasProdutoSelecionadas.has(itemId);
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  async buscarPrecificacoesUF() {
    try {
      this.carregandoService.mostra('buscarPrecificacoesUF');
      this.precificacoesUF = await this.precificacaoUFService.consultar().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPrecificacoesUF');
    }
  }

  calcularPrecificacaoUF(valor: number, precificacaoUF: PrecificacaoUF) {
    return this.precificacaoUFService.calcularPrecificacaoUF(valor, precificacaoUF);
  }

  private loadCidade(item?) {
    this.cidades$ = concat(
      of(item ? [item] : []), // default items
      this.cidadesInput$.pipe(
        distinctUntilChanged(),
        tap(() => (this.cidadesLoading = true)),
        switchMap((term) =>
          this.ibgeService.consultarPorCidade(term).pipe(
            catchError(() => of(item ? [item] : [])), // empty list on error
            tap(() => (this.cidadesLoading = false))
          )
        )
      )
    );
  }

  async buscarCidadesV2() {
    if (this.cidadeSelecionado !== null && this.cidadeSelecionado !== undefined) {
      this.cidade = await this.ibgeService.buscarCidadePorCodIGBE(this.cidadeSelecionado).toPromise();
      this.loadCidade(this.cidade);
      await this.alterouCidade();
    }
  }

  async alterouCidade() {
    if (this.pCentroDistribuicao && this.premissasSistema.habilitarCDPorCidade && this.cliente) {
      if (this.cidadeSelecionado !== null && this.cidadeSelecionado !== undefined) {
        this.cidade = await this.ibgeService.buscarCidadePorCodIGBE(this.cidadeSelecionado).toPromise();
        this.estadoSelecionado = this.cidade.uf;
        if (this.cliente.idCD != this.cidade.cd) {
          this.cliente.idCD = this.cidade.cd;
          this.alterouCD();
        } else {
          this.lojaProdutos ? this.buscarProdutosLoja() : this.buscarProdutos();
        }
      } else {
        this.estadoSelecionado = null;
        this.cliente.idCD = null;
        this.loadCidade();
        this.itensFiltrados = [];
        this.itens = [];
        this.kitsFechadosFiltrados = [];
      }
    } else {
      if (this.cidadeSelecionado !== null && this.cidadeSelecionado !== undefined) {
        this.cidade = await this.ibgeService.buscarCidadePorCodIGBE(this.cidadeSelecionado).toPromise();
        this.estadoSelecionado = this.cidade.uf;
      } else {
        this.estadoSelecionado = null;
      }

      this.lojaProdutos ? this.buscarProdutosLoja() : this.buscarProdutos();
    }
  }

  buscarCidades(nomeCidade?: string) {
    this.buscarCidadesV2();
  }

  alterouCD() {
    this.lojaProdutos ? this.buscarProdutosLoja() : this.buscarProdutos();

    this.trocarCD();
  }
}
